/*
 * Created with vue 2
 * Author: Jay/jaytanweb@163.com
 * Date: 2018/4/18
 * Time: 17:14
 */
<template>
  <div class='simpleCarousel'>
    <div class="carouselContainer" :id="groupId">
      <slot></slot>
    </div>
    <div class="arrows-box" v-if="this.arrow">
      <span class="arrow-back" @click.stop="swipeIt(back)"></span>
      <span class="arrow-forward" @click.stop="swipeIt(forward)"></span>
    </div>
    <div class="button-box" v-if="this.trigger">
      <div class="box">
        <span class="button-item" :class="{ 'button-item-active': item.active }" v-for="(item, index) in bars" :key="index" @click.stop="swipeIt(index)">
          <span class="bar-white" :class="{ 'bar-white-active': item.active }">{{ buttonText[index] }}</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'simpleCarousel',
  props: {
    interval: {
      type: Number,
      required: false,
      default: 1000
    },
    update: {
      type: Boolean,
      required: false
    },
    arrow: {
      type: Boolean,
      required: false,
      default: true
    },
    trigger: {
      type: Boolean,
      required: false,
      default: true
    },
    autoplay: {
      type: Boolean,
      required: false,
      default: false
    },
    id: {
      type: String,
      required: true
    },
    width: {
      type: String,
      required: false
    },
    innerText: {
      type: Array,
      required: false
    }
  },
  computed: {
    forward () { // 计算向前点击后，需要显示的swiper的index
      if (this.showingIndex + 1 > this.child.length - 1) {
        // this.showingIndex = 0
        return 0
      } else {
        return this.showingIndex + 1
      }
    },
    back () { // 计算向后点击后，需要显示的swiper的index
      if (this.showingIndex - 1 < 0) {
        // this.showingIndex = this.child.length - 1
        return this.child.length - 1
      } else {
        return this.showingIndex - 1
      }
    }
  },
  watch: {
    update (n, o) { // 外元素需要更新页面或者数据时，使用props方式传入update值，引发swiper重置
      if (n) this.swipeIt('update')
      console.log('sp-update:', n, o)
    }
  },
  data () {
    return {
      groupId: `G${this.id}`, // swiper父元素id，以props值传入并重新组装
      showingIndex: 0, // 当前正在显示的swiper子元素的index值
      child: [], // swiper子序列，从swiper父元素的子节点序列中筛选
      bars: [], // bar按钮的激活状态序列
      positions: [], // swiper位置序列，transformX，以swiper的宽度为基础计算
      opacity: [], // swiper透明度序列，0或1
      buttonText: [] // bar按钮内部文字，以props值传入
    }
  },
  components: {},
  methods: {
    // emitTitleChange (text) { // 当点击了bar元素，向父元素提交bigTitle修改请求
    //   this.$emit('titleChange', text)
    // },
    swipeIt (option) {
      const $ = document.querySelectorAll.bind(document)
      if (option === 'init' || option === 'update') {
        let nodes = $(`#${this.groupId}`)[0].childNodes
        let nodeWidth = $(`#${this.groupId}`)[0].offsetWidth || this.width
        // 初始化检测
        console.log(this.groupId, ';', option, ';', $(`#${this.groupId}`)[0].offsetWidth, ';', this.width, ';', nodeWidth)
        // 获取全部swiper存为数组child
        this.child = []
        Array.from(nodes).forEach(arr => {
          if (arr.nodeType === 1) {
            this.child.push(arr)
          }
        })
        this.bars = []
        this.positions = []
        this.opacity = []
        this.buttonText = []
        this.child.forEach((arr, index) => {
          // 初始化每个swiper的位置
          if (index < this.child.length - 1) {
            arr.style.transform = `translateX(${nodeWidth * index}px)`
            this.positions.push(`translateX(${nodeWidth * index}px)`)
            arr.style.opacity = '1'
            this.opacity.push('1')
          } else {
            arr.style.transform = `translateX(${nodeWidth * -1}px)`
            this.positions.push(`translateX(${nodeWidth * -1}px)`)
            arr.style.opacity = '0'
            this.opacity.push('0')
          }
          // 初始化bar的数目
          index === 0 ? this.bars.push({ active: true }) : this.bars.push({ active: false })
          // 初始化bar的内文字
          this.buttonText = this.innerText ? this.innerText : []
        })
      } else if (typeof option === 'number') {
        // option取值范围 0 ~ this.child.length - 1
        // 向父元素反馈即将显示的swiper的index数值
        this.$emit('indexChange', option)
        // 根据展示目标option重置每个swiper的位置
        this.child.forEach((arr, index) => {
          if (index >= option) {
            arr.style.transform = this.positions[index - option]
            arr.style.opacity = this.opacity[index - option]
            this.showingIndex = index === option ? option : this.showingIndex
          } else {
            arr.style.transform = this.positions[this.child.length + index - option]
            arr.style.opacity = this.opacity[this.child.length + index - option]
          }
        })
        // bars 动态变换
        this.bars.forEach((arr, index) => {
          arr['active'] = index === option
        })
        console.log(this.showingIndex)
      }
    }
  },
  mounted () {
    // simpleCarousel mounted
    this.swipeIt('init')
  },
  updated () {
    const $ = document.querySelectorAll.bind(document)
    let bars = $('.bar-white')
    // 设置进度条transition
    Array.from(bars).forEach(bar => {
      bar.style.transition = `all ${this.interval / 1000}s`
    })
  }
}
</script>

<style type="text/scss" lang="scss" scoped>
.simpleCarousel {
  //begin you code
  position: relative;
  height: 100%;
  width: 100%;
  .carouselContainer {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    z-index: 2;
  }
  .button-box {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    padding: 0;
    margin: 0;
    z-index: 1;
    .box {
      width: 100%;
      height: 100%;
      .button-item {
        display: inline-block;
        width: 100px;
        height: 5px;
        background: rgba(255, 255, 255, .5);
        margin-right: 5px;
        cursor: pointer;
        .bar-white {
          display: inline-block;
          width: 0;
          height: 100%;
          background: rgba(255, 255, 255, .9);
          text-align: center;
        }
        .bar-white-active {
          width: 100%;
        }
      }
      .button-item-active {

      }
    }
  }
  .arrows-box {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    .arrow-back, .arrow-forward {
      position: absolute;
      width: 50px;
      height: 50px;
      top: 50%;
      transform: translateY(-50%);
      cursor: pointer;
      border-radius: 50%;
      background: rgba(31, 45, 61, .31);
      border: 1px solid rgba(255, 255, 255, .5);
      transition: .3s;
      &:hover {
        background: rgba(31, 45, 61, .53);
        border: 1px solid rgba(255, 255, 255, .7);
      }
    }
    .arrow-back {
      left: 0;
    }
    .arrow-forward {
      right: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/simple/sp-carousel.vue